import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Optometrist icon
 *
 * @category Medical
 */
const Optometrist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M29.643 14.85c-.73-.93-1.96-1.71-2.77-2.86-1.48-2.25-3.03-4.56-5.56-5.75-5.21-2.83-12.39-.83-15.29 4.38-.87 1.88-3.67 3.58-4.07 5.1-.24 1.35 1.19 2.16 2.33 3.39 2 2.34 3.36 5.32 6.33 6.65 3.65 1.97 8.63 1.66 11.98-.77 2.17-1.36 3.22-3.73 4.81-5.62 1.31-1.46 3.42-2.58 2.33-4.37l-.1-.14zm-13.55-9.06c3.56.02 6.99 2.07 8.78 5.09.43.69.59 1.42-.51 1.01-5-2.27-11.45-2.44-16.66-.02-1.14.48-1.15-.09-.64-.94 1.78-3.05 5.23-5.13 8.82-5.14h.22zm9.86 10.31c.34 4.36-9.48 5.36-12.99 4.59-2.67-.74-7.07-1.09-6.96-4.69-.11-3.6 4.29-3.95 6.96-4.69 3.51-.77 13.31.22 12.99 4.59zm-22.8.31c-.43-.64.25-1.09.79-1.45.31-.16.7-.67 1.08-.5-.01.81-.13 1.83 0 2.68.04.24.05.45-.07.47-.47-.07-1.37-.88-1.73-1.12zm12.72 9.81c-3.59-.01-7.04-2.09-8.82-5.14-.5-.83-.52-1.42.64-.94 4.98 2.3 11.29 2.32 16.09.19.38-.14 1.05-.44 1.32-.28.27.19-.06.78-.23 1.08-1.78 3.02-5.21 5.07-8.78 5.09zm12.89-9.71c-.35.23-1.37 1.13-1.8 1.15-.13-.05-.04-.44-.02-.73.1-.8-.01-1.72-.04-2.49.03-.2.27-.09.55.12.59.48 1.98.99 1.4 1.87l-.09.1z"
        />
        <path
          fill="currentColor"
          d="M15.973 17.35a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7"
        />
      </svg>
    );
  }
);

Optometrist.displayName = 'Optometrist';

export { Optometrist };
